import React, { useCallback, useState, memo } from 'react';
import { useToggle } from 'react-use';
import { useSelector } from 'react-redux';
import { useChartSetPreference } from './hooks';
import {
  ChartSetPreferenceFormModal,
  ChartSetPreferenceListModal,
  DeviceChartConsole,
  ChartPreferenceDeleteDialog,
  DeviceChartConfigModal
} from './components';
import { isGa2Device } from 'common/utils/deviceTwinUtils';
import styles from './DeviceChartView.module.css';

function DeviceChartView({ deviceId, marker = false }) {
  const [manageChartSetModalOpened, toggleManageChartSetModalOpened] = useToggle(false);
  const [createChartSetModal, setCreateChartSetModal] = useState(null);
  const [editChartModal, setEditChartModal] = useState(null);
  const [deleteChartModal, setDeleteChartModal] = useState(null);
  const { data, select, update, loading } = useChartSetPreference();
  const activeTabDeviceId = useSelector((state) => state.ui.pivotOverviewPage.activeTab);
  const donor = useSelector((state) => state.ui.singleDevicePage.selectedDevice);

  const disableChartExplorer = activeTabDeviceId !== donor?.deviceId && isGa2Device(donor)

  const openCreateChartSetModal = useCallback((state) => {
    setCreateChartSetModal(state);
  }, []);
  const closeCreateChartSetModal = useCallback(() => {
    setCreateChartSetModal(null);
  }, []);
  const openEditChartModal = useCallback((state) => {
    setEditChartModal(state);
  }, []);
  const closeEditChartModal = useCallback(() => {
    setEditChartModal(null);
  }, []);
  const openDeleteChartModal = useCallback((state) => {
    setDeleteChartModal(state);
  }, []);
  const closeDeleteChartModal = useCallback(() => {
    setDeleteChartModal(null);
  }, []);

  return (
    <div className={styles.root} role="region" aria-label="Device charts" aria-busy={loading}>
      {manageChartSetModalOpened && <ChartSetPreferenceListModal onClose={toggleManageChartSetModalOpened} />}
      {createChartSetModal != null && (
        <ChartSetPreferenceFormModal {...createChartSetModal} onClose={closeCreateChartSetModal} onSelect={select} />
      )}
      {editChartModal != null && (
        <DeviceChartConfigModal {...editChartModal} width={1100} height={300} onClose={closeEditChartModal} />
      )}
      {deleteChartModal != null && (
        <ChartPreferenceDeleteDialog {...deleteChartModal} onClose={closeDeleteChartModal} />
      )}
      <DeviceChartConsole
        deviceId={deviceId}
        preference={data}
        enabledZoom={true}
        enabledMarker={marker}
        displayAxisTitle={true}
        displayActionAnnotation={true}
        displayUserAnnotation={marker}
        displayDataLabel={false}
        displayMarker={marker}
        onSelect={select}
        onUpdate={update}
        onCreate={openCreateChartSetModal}
        onManage={toggleManageChartSetModalOpened}
        onEditChart={openEditChartModal}
        onDeleteChart={openDeleteChartModal}
        disableChartExplorer={disableChartExplorer}
      />
    </div>
  );
}

export default memo(DeviceChartView);
